<template>
    <div>
            <div ref="slider" class="custom-slider minmax">
            <div class="minmax-indicator"></div>
            <input
            ref="inputMin"
            type="range"
            name="min"
            id="min"
            :min="min"
            :max="max"
           
            :step="step"
            @change="onMinInputChange"
            v-model="sliderMinValue"

            />

            <input
            ref="inputMax"
            type="range"
            name="max"
            id="max"
            :min="min"
            :max="max"
            v-model="sliderMaxValue"
            :step="step"

            @change="onMaxInputChange"
            />
        </div>
        <div class="row mt-4">
            <div  class="col-12 font-size-16 text-center">
                {{ sliderMinValue + ' '+ currency }} - {{ sliderMaxValue + ' '+ currency }} 
            </div>

            
        </div>

    </div>
</template>
<script>
export default {
    name: "FilterSliderMinMax",
    props: {
        min: {
            type: Number,
            default: 0,
        },
        max: {
            type: Number,
            default: 500,
        },
        currency:{
          type:String,
        },
        step: {
            type: Number,
            default: 1,
        },

        propMinValue: {
          type: Number,
          default: 0
        },

        propMaxValue: {
          type: Number,
          default: 500
        }
    },

    

    watch :{

        sanitizedSliderMinValue(newVal) {
            this.sliderMinValue = newVal;
        },

        sanitizedSliderMaxValue(newVal) {
            this.sliderMaxValue = newVal;
        },

        propMinValue(newVal) {
          this.sliderMinValue = newVal;
        },

        propMaxValue(newVal) {
          this.sliderMaxValue = newVal;
        }
    },

    data() {
        return {
            sliderMinValue: this.propMinValue,
            sliderMaxValue: this.propMaxValue,
        };
    },

    computed: {
        sanitizedSliderMinValue() {
            return Math.min(this.sliderMinValue, this.sliderMaxValue);
        },
        sanitizedSliderMaxValue() {
            return Math.max(this.sliderMaxValue, this.sliderMinValue);
        },

        selectedPrice() {

          if (this.sliderMinValue == this.min && this.sliderMaxValue == this.max) {
            return null;
          }

          return !this.sliderMinValue && !this.sliderMaxValue ? null : {min: Number(this.sliderMinValue), max: Number(this.sliderMaxValue)};
        }
    },

    methods: {

        onMinInputChange() {

            this.$emit('price-selected', this.selectedPrice);
  

            
        },

        onMaxInputChange() {

            this.$emit('price-selected', this.selectedPrice);
           
        },
    }
};
</script>
  
<style scoped>

.slider-cont {
  width: 300px;
}

.custom-slider {
  --trackHeight: 0.1rem;
  --thumbRadius: 1rem;
}

/* style the input element with type "range" */
.custom-slider input[type="range"] {
  position: relative;
  appearance: none;
  background: none;
  border-radius: 999px;
  z-index: 0;
  height: 100%;
  pointer-events: none;
}

/* ::before element to replace the slider track */
.custom-slider input[type="range"]::before {
  content: "";
  display: block;
  position: absolute;
  width: var(--ProgressPercent, 100%);
  height: 100%;
  background: #ddd;
  border-radius: 999px;
}

/* `::-webkit-slider-runnable-track` targets the track (background) of a range slider in chrome and safari browsers. */
.custom-slider input[type="range"]::-webkit-slider-runnable-track {
  appearance: none;
  background: #ddd;
  height: var(--trackHeight);
  border-radius: 999px;
}

.custom-slider input[type="range"]::-webkit-slider-thumb {
  position: relative;
  width: var(--thumbRadius);
  height: var(--thumbRadius);
  margin-top: calc((var(--trackHeight) - var(--thumbRadius)) / 2);
  background: #121212;
  border: 1px solid  #ddd;
  border-radius: 999px;
  pointer-events: all;
  appearance: none;
  z-index: 1;
}

/* `::-moz-range-track` targets the track (background) of a range slider in Mozilla Firefox. */
.custom-slider.default input[type="range"]::-moz-range-track {
  appearance: none;
  background: #ddd;
  height: var(--trackHeight);
  border-radius: 999px;
}

.custom-slider input[type="range"]::-moz-range-thumb {
  position: relative;
  box-sizing: border-box;
  width: var(--thumbRadius);
  height: var(--thumbRadius);
  margin-top: calc((var(--trackHeight) - var(--thumbRadius)) / 2);
  background: #ddd;
  border: 1px solid  #ddd;
  border-radius: 999px;
  pointer-events: all;
  appearance: none;
  z-index: 1;
}

.custom-slider.minmax {
  position: relative;
  height: var(--trackHeight);
  background: #ddd;
  border-radius: 999px;
  margin: 0.5rem 0;
  --progressLeft: 0%;
  --progressRight: 0%;
}

.custom-slider .minmax-indicator {
  position: absolute;
  height: 100%;
  pointer-events: none;
  left: var(--thumbRadius);
  right: var(--thumbRadius);
}

.custom-slider .minmax-indicator::before {
  content: "";
  position: absolute;
  background: #ddd;
  height: 100%;
  left: var(--progressLeft);
  right: var(--progressRight);
}

.custom-slider.minmax input[type="range"] {
  position: absolute;
  width: calc(100% - var(--thumbRadius));
}

.custom-slider.minmax input[type="range"][name="max"] {
  left: var(--thumbRadius);
}

.custom-slider.minmax input[type="range"]::-webkit-slider-runnable-track {
  background: none;
}

.custom-slider.minmax input[type="range"]::before {
  display: none;
}

</style>
